// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import styles from '../styles/ModuleCloseButton.style';

const CloseButton = ({ className, closeFunc, closeButtonDataLocator }) => (
  <button
    aria-label="close"
    className={`${className} alignTop alignRight`}
    onClick={(e) => closeFunc(e)}
    data-locator={closeButtonDataLocator}
  />
);

CloseButton.propTypes = {
  className: PropTypes.string.isRequired,
  closeFunc: PropTypes.func.isRequired,
  closeButtonDataLocator: PropTypes.string,
};

CloseButton.defaultProps = {
  closeButtonDataLocator: 'close',
};

export default withStyles(CloseButton, styles);
export { CloseButton as CloseButtonVanilla };
